import { inputAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import getThemes, { ThemesKeys } from '../shared/themeShared';

const style = createMultiStyleConfigHelpers(inputAnatomy.keys);

const baseStyle = () =>
  style.definePartsStyle({
    element: {
      w: 'auto',
      h: 'full',
    },
  });

// Definisco le dimensioni per ogni size
const sizes = {
  xs: {
    field: {
      fontSize: 'xs',
      h: '24px',
      px: 3,
    },
  },
  sm: {
    field: {
      fontSize: 'sm',
      h: '32px',
      px: 3,
    },
  },
  md: {
    field: {
      fontSize: 'md',
      h: '40px',
      px: 4,
    },
  },
  lg: {
    field: {
      fontSize: 'lg',
      h: '48px',
      px: 4,
    },
  },
};

const toggle = (theme: ThemesKeys) =>
  style.definePartsStyle({
    field: {
      appearance: 'none',
      cursor: 'pointer',
      bg: getThemes(theme).colors.palette.neutral[60],
      display: 'inline-block',
      w: 12,
      h: 6,
      borderRadius: 'full',
      border: 0,
      _checked: {
        bg: getThemes(theme).colors.palette.primary[50],
      },
      _disabled: {
        bg: getThemes(theme).colors.palette.primary[50],
        opacity: 0.6,
      },
    },
  });

const outline = (theme: ThemesKeys) =>
  style.definePartsStyle({
    field: {
      bg: 'white',
      borderRadius: getThemes(theme).radii.lg,
      color: getThemes(theme).colors.palette.text.secondary[50],
      border: '1px solid',
      borderColor: getThemes(theme).colors.palette.stroke.primary[80],
      boxShadow: 'none',
      _placeholder: {
        color: getThemes(theme).colors.palette.text.secondary[60],
      },
      _hover: {
        borderColor: getThemes(theme).colors.palette.primary[50],
      },
      _focusVisible: {
        zIndex: 1,
        borderColor: getThemes(theme).colors.palette.stroke.primary[50],
        boxShadow: `0 0 0 1px ${getThemes(theme).colors.palette.primary[50]}`,
      },
      _invalid: {
        borderColor: getThemes(theme).colors.palette.errors[50],
        boxShadow: 'none',
        _hover: {
          borderColor: getThemes(theme).colors.palette.errors[50],
        },
        _focusVisible: {
          borderColor: getThemes(theme).colors.palette.errors[50],
          boxShadow: `0 0 0 1px ${getThemes(theme).colors.palette.errors[50]}`,
        },
      },
      _disabled: {
        color: getThemes(theme).colors.palette.text.secondary[80],
        opacity: 1,
        borderColor: getThemes(theme).colors.palette.stroke.secondary[90],
        bg: 'white',
        cursor: 'not-allowed',
        _hover: {
          borderColor: getThemes(theme).colors.palette.stroke.secondary[90],
        },
        _placeholder: {
          color: getThemes(theme).colors.palette.text.secondary[60],
        },
      },
    },
  });

export const inputTheme = (theme: ThemesKeys) =>
  style.defineMultiStyleConfig({
    baseStyle: baseStyle(),
    sizes,
    variants: {
      outline: outline(theme),
      toggle: toggle(theme),
    },
    defaultProps: {
      variant: 'outline',
      size: 'md',
    },
  });

export default (theme: any) => inputTheme(theme);
